import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';
import PageAuthorize from '../../../../security/PageAuthorize';
import RouteTitle from '../../../../presentation/RouteTitle';
import ReactTooltip from 'react-tooltip';
import Overlay from '../../../../presentation/Overlay';
import ASRProjectDialog from './ASRProjectDialog';
import ASRGroupDialog from './ASRGroupDialog';
import ASRRegexDialog from './ASRRegexDialog';

import * as wj from 'wijmo/wijmo.react.grid';
import * as wjcCore from 'wijmo/wijmo';

// Wijmo Key
wjcCore.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

class ASRRegexEditorList extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      asrProject: {},
      asrProjects: [],
      asrProgramsFilter: 0,
      asrPrograms: [],
      asrGroupNameFilter: '',
      asrGroupNames: [],
      asrResultFilter: '',
      asrResultTypes: [],
      regexStrings: [ { Group_Name: 'Filter by a program or project' } ],
      selectedRegexString: {},
      showAsrRegexStringDialog: false,
      showGroupDialog: false,
      showAsrProjectDialog: false,
      isNew: false
    };

    this.onChangeAsrGroupNameFilter = this.onChangeAsrGroupNameFilter.bind( this );
    this.onChangeProgramFilter = this.onChangeProgramFilter.bind( this );
    this.onChangeAsrResultFilter = this.onChangeAsrResultFilter.bind( this );
    this.onDoubleClickRegexString = this.onDoubleClickRegexString.bind( this );
    this.onClickNewGroupName = this.onClickNewGroupName.bind( this );
    this.onClickNewResult = this.onClickNewResult.bind( this );
    this.onClickNewAsrProject = this.onClickNewAsrProject.bind( this );

    this.onCloseDialogs = this.onCloseDialogs.bind( this );
    this.onSaveAsrRegexDialog = this.onSaveAsrRegexDialog.bind( this );
    this.onDeleteAsrRegexDialog = this.onDeleteAsrRegexDialog.bind( this );
    this.onSaveGroupName = this.onSaveGroupName.bind( this );
    this.onSaveNewProject = this.onSaveNewProject.bind( this );

    this.alerts = new Alerts( props.bugsnag, props.dispatch );
    this.title = 'ASR Regex Editor';
    this.wijmoGrid = React.createRef();
    this.wijmoPanel = undefined;
    this.buttonEvents = [];

    this.mounted = false;
  }

  componentDidMount() {
    const asrProgramsPromise = this.apiPgmAsr( 'GET', [] );
    const asrProjectsPromise = this.apiAsrProjects( 'GET', [] );

    this.mounted = true;

    this.mounted && Promise.all( [ asrProgramsPromise, asrProjectsPromise ] )
      .then( ( [ asrProgramsResults, asrProjectsResults ] ) => {
        this.mounted && this.setState( {
          asrPrograms: asrProgramsResults,
          asrProjects: asrProjectsResults
        } );
      } )
      .catch( ( exception ) => {
        this.onHandleException( exception );
      } );
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  /********************************************************************************************************************
   * HELPER FUNCTIONS
   *******************************************************************************************************************/

  doLogOff() {
    const { dispatch } = this.props;
    const auth = this.props.auth;
    const history = this.props.history;

    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const status = e.status === undefined ? 0 : e.status;

    if ( status === 410 ) {
      this.alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      this.alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        this.alerts.CRITICAL( this.title, e, false );
      } else {
        this.alerts.CRITICAL( this.title, e );
      }
    }
  }

  /********************************************************************************************************************
   * API EVENTS
   *******************************************************************************************************************/

  apiPgmAsr( request, params ) {
    switch ( request ) {
      case 'GET':
        return new EtelAPI( 'asr/project/pgmasr' ).get( params );
      default:
        break;
    }
  }

  apiRegexStrings( request, params ) {
    switch ( request ) {
      case 'DELETE':
        return new EtelAPI( 'asr/regex/string' ).delete( params );
      case 'GET':
        return new EtelAPI( 'asr/regex/string' ).get( params );
      case 'POST':
        return new EtelAPI( 'asr/regex/string' ).insert( params );
      case 'PUT':
        return new EtelAPI( 'asr/regex/string' ).update( params );
      default:
        break;
    }
  }

  apiAsrProjects( request, params ) {
    switch ( request ) {
      case 'DELETE':
        return new EtelAPI( 'asr/project' ).delete( params );
      case 'GET':
        return new EtelAPI( 'asr/project' ).get( params );
      case 'POST':
        return new EtelAPI( 'asr/project' ).insert( params );
      default:
        break;
    }
  }

  apiAsrGroups( request, params ) {
    switch ( request ) {
      case 'GET':
        return new EtelAPI( 'asr/group' ).get( params );
      case 'POST':
        return new EtelAPI( 'asr/group' ).insert( params );
      default:
        break;
    }
  }

  /********************************************************************************************************************
   * EVENT HANDLERS
   *******************************************************************************************************************/

  /**
   * Event for changing the Project or Program filter.
   */
  onChangeProgramFilter( e ) {
    if ( parseInt( e.target.value, 10 ) === 0 ) {
      this.setState( {
        asrProject: { ASR_Project_ID: 0 },
        regexStrings: [ { Group_Name: 'Filter by a program or project' } ],
        asrGroupNames: [],
        asrResultTypes: [],
        asrProgramsFilter: 0
      } );

      return;
    }

    const targetName = e.target.name;
    const targetValue = e.target.value;
    const filteredProjectId = targetName === 'asrProgram'
      ? this.state.asrPrograms.filter( ( asrProgram ) => {
        return parseInt( asrProgram.PGM_ASR_ID, 10 ) === parseInt( targetValue, 10 );
      } )[ 0 ].ASR_Project_ID
      : parseInt( targetValue, 10 );
    const params = [ { ASR_Project_ID: filteredProjectId } ];

    const regexStringsPromise = this.apiRegexStrings( 'GET', params );
    const asrProjectsPromise = this.apiAsrProjects( 'GET', params );
    const asrGroupNamesPromise = this.apiAsrGroups( 'GET', params );

    Promise.all( [ regexStringsPromise, asrProjectsPromise, asrGroupNamesPromise ] )
      .then( ( [ regexStringsResults, asrProjectsResults, asrGroupNamesResults ] ) => {
        const asrResultTypes = [
          ...new Set(
            regexStringsResults.map( ( regexString ) => {
              return regexString.Result;
            } )
          ),
        ];

        this.setState( {
          asrProject: asrProjectsResults.length > 0 ? asrProjectsResults[ 0 ] : {},
          asrProgramsFilter: targetName === 'asrProject' ? 0 : targetValue,
          regexStrings: regexStringsResults,
          asrGroupNames: asrGroupNamesResults,
          asrResultTypes: asrResultTypes,
        } );
      } )
      .catch( ( exception ) => {
        this.onHandleException( exception );
      } );
  }

  /**
   * Event for changing the Group Name filter.
   */
  onChangeAsrGroupNameFilter( e ) {
    const filteredGroupName = e.target.value;
    const filteredProjectId = this.state.asrProject.ASR_Project_ID;
    const filteredResult = this.state.asrResultFilter;

    this.setState( {
      asrGroupNameFilter: filteredGroupName
    }, () => {
      const params = [
        { ASR_Project_ID: filteredProjectId },
        { Group_Name: filteredGroupName },
        { Result: filteredResult }
      ];

      this.apiRegexStrings( 'GET', params )
        .then( ( regexStringsResults ) => {
          this.setState( {
            regexStrings: regexStringsResults,
          } );
        } )
        .catch( ( exception ) => {
          this.onHandleException( exception );
        } );
    } );
  }

  /**
   * Event for changing the ASR Result filter.
   */
  onChangeAsrResultFilter( e ) {
    const filteredResult = e.target.value;
    const filteredProjectId = this.state.asrProject.ASR_Project_ID;
    const filteredGroupName = this.state.asrGroupNameFilter;

    this.setState( {
      asrResultFilter: filteredResult,
    }, () => {
      const params = [
        { ASR_Project_ID: filteredProjectId },
        { Group_Name: filteredGroupName },
        { Result: filteredResult },
      ];

      this.apiRegexStrings( 'GET', params )
        .then( ( regexStringsResults ) => {
          this.setState( {
            regexStrings: regexStringsResults,
          } );
        } )
        .catch( ( exception ) => {
          this.onHandleException( exception );
        } );
    } );
  }

  /**
   * Event for double clicking on a Regex String. Opens up the dialog for editing.
   */
  onDoubleClickRegexString( e ) {
    const selectedRegexString = this.wijmoPanel.control.selectedItems[ 0 ];
    selectedRegexString.Project_Name = this.state.asrProject.Project_Name;

    this.setState( {
      selectedRegexString: selectedRegexString,
      showAsrRegexStringDialog: true,
    } );
  }

  /**
   * Event for clicking the New Group Name button. Opens up the dialog to create a new group name.
   */
  onClickNewGroupName( e ) {
    this.setState( {
      showGroupDialog: true,
    } );
  }

  /**
   * Event for clicking the New ASR Project button. Opens up the dialog to create a new ASR Project.
   */
  onClickNewAsrProject( e ) {
    this.setState( {
      showAsrProjectDialog: true
    } );
  }

  /**
   * Event for cicking the New ASR Result button. Opens up the dialog to create a new ASR Result.
   */
  onClickNewResult( e ) {
    const selectedRegexString = {
      Regex_String_ID: -1,
      Project_Name: this.state.asrProject.Project_Name,
      ASR_Project_ID: this.state.asrProject.ASR_Project_ID,
      Group_Name: 'TBD',
      Result: 'TBD',
      Regex_String: '',
      Order_ID: 'TBD'
    };

    this.setState( {
      showAsrRegexStringDialog: true,
      isNew: true,
      selectedRegexString: selectedRegexString
    } );
  }

  /**
   * Event for clicking confirm on saving the Regex String. Closes all dialogs and refreshes the regex strings to show
   * the latest updates.
   *
   * @param {Object} updatedAsrRegexString The Regex string to update or insert.
   */
  onSaveAsrRegexDialog( updatedAsrRegexString ) {
    let request = parseInt( updatedAsrRegexString.Regex_String_ID, 10 ) === -1 ? 'POST' : 'PUT';

    this.apiRegexStrings( request, updatedAsrRegexString )
      .then( ( updatedResult ) => {
        this.alerts.SUCCESS( this.title, 'Successfully created regex string', 5000 );

        return this.apiRegexStrings( 'GET', [ { ASR_Project_ID: updatedResult.data[ 0 ].ASR_Project_ID } ] );
      } )
      .then( ( regexStringResults ) => {
        this.setState( {
          regexStrings: regexStringResults
        } );
      } )
      .catch( ( exception ) => {
        this.onHandleException( exception );
      } )
      .finally( () => {
        this.setState( {
          showAsrRegexStringDialog: false,
          isNew: false
        } );
      } );
  }

  /**
   * Event for clicking confirm on deleting the Regex String. Deletes the Regex String and closes all dialogs to
   * refresh the regex strings to show the latest updates.
   *
   * @param {int} regexStringId The Regex_String_ID to delete.
   */
  onDeleteAsrRegexDialog( regexStringId ) {
    this.apiRegexStrings( 'DELETE', regexStringId )
      .then( ( deletedRegexString ) => {
        this.alerts.SUCCESS( this.title, 'Successfully deleted regex string', 5000 );

        return this.apiRegexStrings( 'GET', [ { ASR_Project_ID: this.state.asrProject.ASR_Project_ID } ] );
      } )
      .then( ( regexStringResults ) => {
        this.setState( {
          asrGroupNameFilter: '',
          asrResultFilter: '',
          regexStrings: regexStringResults
        } );
      } )
      .catch( ( exception ) => {
        this.onHandleException( exception );
      } )
      .finally( () => {
        this.setState( {
          showAsrRegexStringDialog: false,
        } );
      } );
  }

  /**
   * Event for clicking confirm on creating the Group Name for the selected ASR Project.
   * 
   * @param {Object} newGroupName The new Group Name to create for the selected ASR Project.
   */
  onSaveGroupName( newGroupName ) {
    newGroupName.ASR_Project_ID = this.state.asrProject.ASR_Project_ID;

    this.apiAsrGroups( 'POST', newGroupName )
      .then( ( newGroupResult ) => {
        const newAsrGroupNames = [ ...this.state.asrGroupNames ];
        newAsrGroupNames.push( newGroupResult.data[ 0 ] );

        this.alerts.SUCCESS( this.title, 'Successfully created new group', 5000 );

        this.setState( {
          showGroupDialog: false,
          asrGroupNames: newAsrGroupNames
        } );
      } )
      .catch( ( exception ) => {
        this.onHandleException( exception );
      } );
  }

  /**
   * Event for clicking confirm on creating a new ASR Project.
   * 
   * @param {Object} newProject The new ASR Project.
   */
  onSaveNewProject( newProject ) {
    this.apiAsrProjects( 'POST', newProject )
      .then( ( newAsrProject ) => {
        const updatedAsrProjects = [ ...this.state.asrProjects ];
        updatedAsrProjects.push( newAsrProject.data[ 0 ] );

        this.alerts.SUCCESS( this.title, 'Successfully created new ASR project.', 5000 );

        this.setState( {
          asrProject: newAsrProject.data[ 0 ],
          asrProjects: updatedAsrProjects,
          showAsrProjectDialog: false,
          regexStrings: [ {} ],
          asrProgramsFilter: 0,
          asrGroupNames: [],
          asrResultTypes: []
        } );
      } )
      .catch( ( exception ) => {
        this.onHandleException( exception );
      } );
  }

  /**
   * Event handler to close any dialogs that this page renders.
   */
  onCloseDialogs() {
    this.setState( {
      showAsrRegexStringDialog: false,
      showGroupDialog: false,
      showAsrProjectDialog: false,
      isNew: false,
      selectedRegexString: {}
    } );
  }

  /********************************************************************************************************************
   * RENDERS
   *******************************************************************************************************************/

  renderAsrProjectsFilterOptions() {
    const asrProjectsFilterOptions = this.state.asrProjects.map( ( asrProject ) => {
      return (
        <option key={asrProject.ASR_Project_ID} value={asrProject.ASR_Project_ID}>
          {asrProject.ASR_Project_ID} - {asrProject.Project_Name}
        </option>
      );
    } );

    asrProjectsFilterOptions.unshift(
      <option key={0} value={0}>
        Select...
      </option>
    );

    return asrProjectsFilterOptions;
  }

  renderAsrProgramsFilterOptions() {
    const asrProgramsFilterOptions = this.state.asrPrograms.map( ( asrProgram ) => {
      return (
        <option key={asrProgram.PGM_ASR_ID} value={asrProgram.PGM_ASR_ID}>
          {asrProgram.PDNIS} - {asrProgram.PROGRAM_NAME}
        </option>
      );
    } );

    asrProgramsFilterOptions.unshift(
      <option key={0} value={0}>
        Select...
      </option>
    );

    return asrProgramsFilterOptions;
  }

  renderAsrGroupNameFilterOptions() {
    const asrGroupNameFilterOptions = this.state.asrGroupNames.map( ( groupName ) => {
      return (
        <option key={groupName.ASR_Group_Name_ID} value={groupName.Group_Name}>
          {groupName.Group_Name}
        </option>
      );
    } );

    asrGroupNameFilterOptions.unshift(
      <option key={0} value={''}>
        {
          [ undefined, null, 0 ].includes( this.state.asrProject.ASR_Project_ID )
            ? 'Filter by a program or project first'
            : 'All'
        }
      </option>
    );

    return asrGroupNameFilterOptions;
  }

  renderAsrResultFilterOptions() {
    const asrResultFilterOptions = this.state.asrResultTypes.map( ( asrResult, index ) => {
      return (
        <option key={asrResult} value={asrResult}>
          {asrResult}
        </option>
      );
    } );

    asrResultFilterOptions.unshift(
      <option key={0} value={''}>
        {
          [ undefined, null, 0 ].includes( this.state.asrProject.ASR_Project_ID )
            ? 'Filter by a program or project first'
            : 'All'
        }
      </option>
    );

    return asrResultFilterOptions;
  }

  renderProgramFilters() {
    return (
      <div className='asr-regex-editor-list-filter'>
        <span className='asr-regex-editor-list-filter-item'>
          <span className='asr-regex-editor-list-row-project-label'> Project: </span>
          <select
            id='asr-project-filter'
            data-tip='asr-project-filter'
            data-for='asr-project-filter'
            name='asrProject'
            className='asr-regex-editor-list-row-project-dropdown'
            onChange={this.onChangeProgramFilter}
            value={this.state.asrProject.ASR_Project_ID}
          >
            {this.renderAsrProjectsFilterOptions()}
          </select>
          <ReactTooltip
            id='asr-project-filter'
            type='info'
          >
            Filter by Project or by Program
          </ReactTooltip>
        </span>
        <span className='asr-regex-editor-list-filter-item'>
          <span className='asr-regex-editor-list-row-project-label'> Program: </span>
          <select
            id='asr-program-filter'
            data-tip='asr-program-filter'
            data-for='asr-program-filter'
            name='asrProgram'
            className='asr-regex-editor-list-row-project-dropdown'
            onChange={this.onChangeProgramFilter}
            value={this.state.asrProgramsFilter}
          >
            {this.renderAsrProgramsFilterOptions()}
          </select>
          <ReactTooltip
            id='asr-program-filter'
            type='info'
          >
            Filter by Project or by Program
          </ReactTooltip>
        </span>
        <span className='asr-regex-editor-list-filter-item'>
          <span className='asr-regex-editor-list-row-project-label'> Group Name: </span>
          <select
            className='asr-regex-editor-list-row-project-dropdown'
            onChange={this.onChangeAsrGroupNameFilter}
            value={this.state.asrGroupNameFilter}
          >
            {this.renderAsrGroupNameFilterOptions()}
          </select>
          {
            ![ undefined, null, 0 ].includes( this.state.asrProject.ASR_Project_ID )
            &&
            <Fragment>
              <i
                className='icon-fontello-plus-1 new-item-icon'
                id='new-group-icon'
                data-tip='new-group-icon'
                data-for='new-group-icon'
                onClick={this.onClickNewGroupName}
              />
              <ReactTooltip id='new-group-icon' type='info'>
                Add New Group
              </ReactTooltip>
            </Fragment>
          }
        </span>
        <span className='asr-regex-editor-list-filter-item'>
          <span className='asr-regex-editor-list-row-project-label'> Result: </span>
          <select
            className='asr-regex-editor-list-row-project-dropdown'
            onChange={this.onChangeAsrResultFilter}
            value={this.state.asrResultFilter}
          >
            {this.renderAsrResultFilterOptions()}
          </select>
          {
            ![ undefined, null, 0 ].includes( this.state.asrProject.ASR_Project_ID )
            &&
            this.state.asrGroupNames.length > 0
            &&
            <Fragment>
              <i
                className='icon-fontello-plus-1 new-item-icon'
                id='new-result-icon'
                data-tip='new-result-icon'
                data-for='new-result-icon'
                onClick={this.onClickNewResult}
              />
              <ReactTooltip id='new-result-icon' type='info'>
                Add New Result
              </ReactTooltip>
            </Fragment>
          }
        </span>
        <span className='asr-regex-editor-list-filter-item'>
          <span className='asr-regex-editor-list-row-project-label'> Programs using this regex: </span>
          <span> {this.state.asrProject.Programs} </span>
        </span>
      </div>
    );
  }

  renderRegexStrings() {
    return (
      <div className='asr-regex-editor-list-regex-strings' ref={this.wijmoGrid} onDoubleClick={this.onDoubleClickRegexString}>
        <wj.FlexGrid
          ref={( panel ) => ( this.wijmoPanel = panel )}
          itemsSource={this.state.regexStrings}
          selectionMode='CellRange'
          autoClipboard={true}
          onCellEditEnded={this.onCellChanged}
          allowAddNew={false}
        >
          <wj.FlexGridColumn header='Group Name' binding='Group_Name' width='*' isContentHtml={true} isReadOnly={true} />
          <wj.FlexGridColumn header='Result' binding='Result' width='*' isContentHtml={true} isReadOnly={true} />
          <wj.FlexGridColumn header='Order' binding='Order_ID' width='*' isContentHtml={true} isReadOnly={true} />
          <wj.FlexGridColumn header='Regex String' binding='Regex_String' width='5*' isContentHtml={true} isReadOnly={true} />
        </wj.FlexGrid>
      </div>
    );
  }

  render() {
    const showOverlay = this.state.showAsrRegexStringDialog ||
      this.state.showGroupDialog ||
      this.state.showAsrProjectDialog;

    return (
      <PageAuthorize groups={[ 'Administrators', 'Operations', 'Management' ]}>
        <RouteTitle title={this.title} />
        <div className='asr-regex-editor-list'>
          <div className='asr-regex-editor-list-header'>
            <span className='asr-regex-editor-list-header-title'> {this.title} </span>
            <button className='asr-regex-editor-new-asr-project-button' onClick={this.onClickNewAsrProject}> New ASR Project </button>
          </div>
          {this.renderProgramFilters()}
          {this.renderRegexStrings()}
          {
            this.state.showAsrRegexStringDialog
            &&
            <ASRRegexDialog
              show={this.state.showAsrRegexStringDialog}
              selectedRegexString={this.state.selectedRegexString}
              asrGroupNames={this.state.asrGroupNames}
              onClose={this.onCloseDialogs}
              onSave={this.onSaveAsrRegexDialog}
              onDelete={this.onDeleteAsrRegexDialog}
              isNew={this.state.isNew}
            />
          }
          {
            this.state.showGroupDialog
            &&
            <ASRGroupDialog
              show={this.state.showGroupDialog}
              selectedRegexString={this.state.selectedRegexString}
              onClose={this.onCloseDialogs}
              onSave={this.onSaveGroupName}
            />
          }
          {
            this.state.showAsrProjectDialog
            &&
            <ASRProjectDialog
              show={this.state.showAsrProjectDialog}
              onClose={this.onCloseDialogs}
              onSave={this.onSaveNewProject}
            />
          }
          {showOverlay && <Overlay show={showOverlay} />}
        </div>
      </PageAuthorize>
    );
  }
}

export default withRouter(
  connect( ( store ) => {
    return {
      auth: store.auth.auth,
      bugsnag: store.bugsnag.Bugsnag,
      user: store.user.user,
    };
  } )( ASRRegexEditorList )
);



// WEBPACK FOOTER //
// ./src/content/enterprise/asr/components/ASRRegexEditorList.js